import jwt from 'jwt-decode';

export const decodeJwtMfa = (token: string): JWTokenMfaPayload => {
  const payload = jwt(token)
  return payload as JWTokenMfaPayload
}

export interface JWTokenMfaPayload {
  userId: number
  session_id: string
  status: string
}
